import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    paidUser:false,
};

 const userSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
      paidStatus: (state, action) => {
        state.paidUser = action.payload;
      },

  },
});

export const {paidStatus} = userSlice.actions;

export default userSlice.reducer;
